import React from "react";
import { Grid, FormLabel } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiBox from "components/SuiBox";
import { Close } from "./index";

const FileUploadUI = ({
  id,
  name,
  label,
  accept,
  required,
  fileValue,
  getFile,
  removeFileName,
}) => {
  const [fileNames, setFileNames] = React.useState([]);
  React.useEffect(() => {
    if (fileValue) {
      if (Array.isArray(fileValue)) {
        setFileNames(
          fileValue.map((file) => {
            return (
              typeof file === "string" ? file : (file.name || file.fileName)
            )
          })
        );
      } else if (typeof fileValue === "string") {
        setFileNames([fileValue]);
      } else if (fileValue instanceof File) {
        setFileNames([fileValue.name]);
      } else {
        setFileNames([]);
      }
    } else {
      setFileNames([]);
    }
  }, [fileValue]);

  const handleFileUpload = (e) => {
    if (!e.target.files.length) {
      setFileNames([]);
      return;
    }

    const files = Array.from(e.target.files);
    setFileNames(files.map((file) => file.name));
    getFile(files);

    // https://github.com/ngokevin/react-file-reader-input/issues/11#issuecomment-363484861
    // Reset the input value after processing the files
    e.target.value = '';
  };

  const removeFile = (name) => {
    // const fileInput = document.getElementById(id);
    // fileInput.value = "";
    // setFileNames([]);
    removeFileName(name);
    // getFile(null);
  };

  // Render each file or a placeholder if none
  return (
    <>
      <FormLabel htmlFor={id} required={required}>
        {label}
      </FormLabel>
      <Grid container spacing={2} alignItems="center">
        <Grid item sx={{ flexGrow: 1 }}>
          <SuiBox display="flex" title="No file chosen">
            <SuiInput
              value=""
              type="text"
              placeholder={label}
              inputProps={{
                readOnly: true,
                sx: { "&:focus": { border: "0.125rem solid #D3E0E5" } },
              }}
              sx={{ flexGrow: 1 }}
            />
            <SuiButton
              buttonColor="info"
              size="small"
              sx={{
                ml: -1.5,
                px: 2,
                fontWeight: 400,
                "&:hover": { transform: "none" },
              }}
              component="label"
              htmlFor={id}
              startIcon={<FileUploadOutlinedIcon />}
            >
              Upload
            </SuiButton>
          </SuiBox>
        </Grid>
      </Grid>
      <Grid container sx={{ display: "flex", flexWrap: "wrap", gap: '12px' }} mt={2}>
        {fileNames.map((name, index) => {
          const displayName =
            name?.length > 30
              ? `${name.slice(0, 18)}...${name.slice(name.length - 18)}`
              : name;

          return (
            <Grid item key={index}>
              <SuiBox
                position="relative"
                borderRadius="5px"
                display="inline-block"
                py={1}
                px={2}
                my={1}
                sx={{ bgcolor: "#f4f4f4 !important" }}
                title={name}
              >
                <Close onClose={() => removeFile(name)} />
                {displayName}
              </SuiBox>
            </Grid>
          );
        })}
      </Grid>
      <SuiInput
        id={id}
        name={name}
        type="file"
        inputProps={{
          sx: { display: "none" },
          hidden: true,
          required: required,
          multiple: true,
          accept: accept,
        }}
        onChange={handleFileUpload}
      />
    </>
  );
};
export default FileUploadUI;
